// extracted by mini-css-extract-plugin
module.exports = {"root":"Dsbq2","avatar":"_1j72l"};